import { render, staticRenderFns } from "./MenuProjects.vue?vue&type=template&id=21d9b894"
import script from "./MenuProjects.vue?vue&type=script&lang=js"
export * from "./MenuProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports